export default {
  form_output: {
    missing_answer: 'Missing Answer',
    cancel_paid_choice: 'Cancel Item',
    cancel_paid_choice_modal: {
      title: 'Cancel Item',
      select_paid_choice: 'Items',
      total_refundable_hint:
        'This amount is estimated based on previous payments and refunds. The total refundable amount could be different.',
      subtotal: 'Subtotal',
      gst: 'GST',
      qst: 'QST',
      hst: 'HST',
      vat: 'VAT',
      pst: 'PST',
      total: 'Total Paid',
      total_refundable: 'Total Refundable',
      forward_payment_warning: `This item cannot be cancelled because it's associated to an invoice that has been forwarded.`,
      steps: {
        select: {
          title: 'Select Item',
          subtitle: 'This field has multiple answers. Select the item you wish to cancel.',
        },
        confirmation: {
          title: 'Confirmation',
          subtitle: 'Confirm cancellation',
          subtitle_caption: 'Please note that the visibility of conditionnal fields might be affected.',
        },
      },
      action_button: 'Confirm',
      is_refund_requested: 'Would you like to issue a refund?',
      refund_amount: 'Amount',
    },
  },
};
